// must be .js file, can't modify to be .ts file!

export { default } from './theme/common/Loading';
